import { DOCUMENT, Inject, inject, Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "../../environments/environment";
import { BehaviorSubject, firstValueFrom, Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class LocalizationService {
  private translate = inject(TranslateService);
  private currentLang$ = new BehaviorSubject<string>('');

  constructor(@Inject(DOCUMENT) private document: Document) {
    this.translate.addLangs(environment.supportedLangs);
    this.translate.setFallbackLang(environment.defaultLang);
  }

  async setLanguage(lang: string): Promise<void> {

    try {
       if (lang === this.currentLang$.value) { return; }
      if (lang != '') {
        this.currentLang$.next(lang);
      } else {
        this.currentLang$.next(environment.defaultLang);
      }
      // translate.use returns an Observable — wait for its first emission
      await firstValueFrom(this.translate.use(lang));
    } catch (err) {
      // fallback on error: restore default and attempt to load it
      this.currentLang$.next(environment.defaultLang);
      try {
        await firstValueFrom(this.translate.use(environment.defaultLang));
      } catch (err) {
        console.error('Error loading default language', environment.defaultLang, err);
      }
    }
    this.setHtmlLangAttributes(lang);
  }


  setHtmlLangAttributes(lang: string): void {
    if (lang) {
      this.document.documentElement.lang = lang;
      this.document.documentElement.dir = this.translate.instant('langDirection');
    }
  }




  getLanguage(): Observable<string> {
    return this.currentLang$.asObservable();
  }

  getCurrentLang(): string {
    return this.currentLang$.value;
  }
}

